(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-grid-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const observers = new WeakMap();
  const selector = '.hero-grid-carousel .hero-grid__swiper';

  function initContrast(root) {
    root.querySelectorAll(selector).forEach((carousel) => {
      if (observers.has(carousel)) return;
      const slides = carousel.querySelector('.swiper-wrapper');
      const buttons = carousel.querySelectorAll('.hero-grid__swiper-controls .swiper-button');
      const pagination = carousel.querySelector('.hero-grid__swiper-controls .swiper-pagination');
      if (!slides || !buttons.length) return;

      function updateContrast() {
        const activeSlide = slides.querySelector('.swiper-slide-active') || slides.querySelector('.swiper-slide');
        const isLight = activeSlide?.classList.contains('hero-grid__slide--light') || false;
        buttons.forEach((button) => button.classList.toggle('swiper-button--dark', isLight));
        pagination?.classList.toggle('swiper-pagination--progress--dark', isLight);
      }

      const observer = new MutationObserver(updateContrast);
      observer.observe(slides, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      observers.set(carousel, observer);
      updateContrast();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initContrast(document), { once: true });
  } else {
    initContrast(document);
  }
  document.addEventListener('shopify:section:load', (event) => initContrast(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((carousel) => {
      observers.get(carousel)?.disconnect();
      observers.delete(carousel);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
